// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ta-z","bodyOpen":"ua-z","content":"va-z","header":"wa-z","close":"xa-z","closeNoHeading":"ya-z"};